"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isRuleOperatorType(rule) {
    return 'left' in rule && 'right' in rule;
}
exports.isRuleOperatorType = isRuleOperatorType;
function isRuleGroupType(rule) {
    return 'group' in rule;
}
exports.isRuleGroupType = isRuleGroupType;
function isRuleScheduleType(rule) {
    return 'startDatetime' in rule;
}
exports.isRuleScheduleType = isRuleScheduleType;
function supportsIndexOf(value) {
    return typeof value === 'string' || Array.isArray(value);
}
exports.supportsIndexOf = supportsIndexOf;
function isPresentation(toBeDetermined) {
    if ('applicationName' in toBeDetermined) {
        return true;
    }
    return false;
}
exports.isPresentation = isPresentation;
exports.weekdays = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
function isRecurrenceRule(item) {
    if (!item)
        return false;
    if (!item.freq || typeof item.freq !== 'string')
        return false;
    if (!item.dtstart || typeof item.dtstart !== 'string')
        return false;
    if (!item.interval || typeof item.interval !== 'number')
        return false;
    // Check if the byday field is correct.
    if (item.byday === null || item.byday === undefined)
        return true;
    return (Array.isArray(item.byday) &&
        item.byday.every(function (v) { return exports.weekdays.includes(v); }));
}
exports.isRecurrenceRule = isRecurrenceRule;
function isScheduleRuleValue(item) {
    if (!item)
        return false;
    if (!item.startDatetime || typeof item.startDatetime !== 'string')
        return false;
    if (!item.endDatetime || typeof item.endDatetime !== 'string')
        return false;
    if (!item.tzid || typeof item.tzid !== 'string')
        return false;
    if (!item.recurrenceRule)
        return true;
    return isRecurrenceRule(item.recurrenceRule);
}
exports.isScheduleRuleValue = isScheduleRuleValue;
function isIntersection(leftArray, rightArray) {
    var intersection = leftArray.filter(function (x) { return rightArray.includes(x); });
    return !!intersection.length && rightArray.length === intersection.length;
}
exports.isIntersection = isIntersection;
function isArrayEqual(leftArray, rightArray) {
    var isEqual = leftArray.every(function (x) { return rightArray.includes(x); });
    return isEqual && leftArray.length === rightArray.length;
}
exports.isArrayEqual = isArrayEqual;
